module.exports = __webpack_public_path__ + "img/employ_1.4ac95411.png";